/* KTS Cartridge & Stylus Compatibility Checker v1
 * Match phono cartridges to turntables, compute tonearm-cartridge resonance,
 * recommend VTF, anti-skate and alignment. All client-side. DB inline.
 * Specs from manufacturer datasheets. Marked "approx" where vintage/unverified.
 */
function _ccT(k, fallback) { return (window.KTS_CC_I18N && window.KTS_CC_I18N[k]) || fallback; }

/* TURNTABLES DB
 * Fields:
 *  m = manufacturer
 *  n = model
 *  mass = tonearm effective mass (g)
 *  mount = 'half'(1/2 inch) | 'p' (P-mount) | 'fixed' (sealed/non-replaceable)
 *  vtfMin/vtfMax = tracking force range supported (g)
 *  arm = pivoted | linear
 *  notes = optional caveats
 */
const KTS_CC_TURNTABLES = [
  {m:'Audio-Technica',n:'AT-LP60X',mass:9,mount:'fixed',vtfMin:3,vtfMax:3,arm:'pivoted',notes:'Fixed AT3600L cartridge, not replaceable'},
  {m:'Audio-Technica',n:'AT-LP120XBT-USB',mass:14,mount:'half',vtfMin:1,vtfMax:4,arm:'pivoted'},
  {m:'Audio-Technica',n:'AT-LP140XP',mass:14,mount:'half',vtfMin:1,vtfMax:5,arm:'pivoted'},
  {m:'Audio-Technica',n:'AT-LPW40WN',mass:18,mount:'half',vtfMin:1,vtfMax:3,arm:'pivoted'},
  {m:'Audio-Technica',n:'AT-LPW50PB',mass:18,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted'},
  {m:'Pro-Ject',n:'Debut Carbon EVO',mass:11,mount:'half',vtfMin:1.5,vtfMax:2,arm:'pivoted'},
  {m:'Pro-Ject',n:'Debut PRO',mass:11,mount:'half',vtfMin:1.5,vtfMax:2,arm:'pivoted'},
  {m:'Pro-Ject',n:'X1',mass:11,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted'},
  {m:'Pro-Ject',n:'X2',mass:13,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted'},
  {m:'Pro-Ject',n:'The Classic',mass:14,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted'},
  {m:'Pro-Ject',n:'RPM 3 Carbon',mass:11,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted'},
  {m:'Rega',n:'Planar 1',mass:11,mount:'half',vtfMin:1.5,vtfMax:2,arm:'pivoted',notes:'RB110 tonearm'},
  {m:'Rega',n:'Planar 2',mass:11,mount:'half',vtfMin:1.75,vtfMax:2,arm:'pivoted',notes:'RB220 tonearm'},
  {m:'Rega',n:'Planar 3',mass:11,mount:'half',vtfMin:1.75,vtfMax:2,arm:'pivoted',notes:'RB330 tonearm'},
  {m:'Rega',n:'Planar 6',mass:11,mount:'half',vtfMin:1.75,vtfMax:2,arm:'pivoted',notes:'RB330 tonearm'},
  {m:'Rega',n:'Planar 8',mass:11,mount:'half',vtfMin:1.75,vtfMax:2.25,arm:'pivoted',notes:'RB880 tonearm'},
  {m:'Technics',n:'SL-1200 Mk7',mass:12,mount:'half',vtfMin:0,vtfMax:4,arm:'pivoted'},
  {m:'Technics',n:'SL-1500C',mass:12,mount:'half',vtfMin:0,vtfMax:4,arm:'pivoted'},
  {m:'Technics',n:'SL-1210GR',mass:12,mount:'half',vtfMin:0,vtfMax:4,arm:'pivoted'},
  {m:'Music Hall',n:'MMF-1.3',mass:10,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted'},
  {m:'Music Hall',n:'MMF-2.3',mass:10,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted'},
  {m:'Music Hall',n:'MMF-5.3',mass:11,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted'},
  {m:'Music Hall',n:'MMF-7.3',mass:11,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted'},
  {m:'Fluance',n:'RT81',mass:18,mount:'half',vtfMin:2,vtfMax:3,arm:'pivoted'},
  {m:'Fluance',n:'RT82',mass:18,mount:'half',vtfMin:1.5,vtfMax:3,arm:'pivoted'},
  {m:'Fluance',n:'RT83',mass:18,mount:'half',vtfMin:1.5,vtfMax:3,arm:'pivoted'},
  {m:'Fluance',n:'RT85',mass:18,mount:'half',vtfMin:1.5,vtfMax:3,arm:'pivoted'},
  {m:'U-Turn',n:'Orbit Basic',mass:10,mount:'half',vtfMin:1,vtfMax:3,arm:'pivoted'},
  {m:'U-Turn',n:'Orbit Plus',mass:10,mount:'half',vtfMin:1.5,vtfMax:3,arm:'pivoted'},
  {m:'U-Turn',n:'Orbit Special',mass:10,mount:'half',vtfMin:1.5,vtfMax:3,arm:'pivoted'},
  {m:'Denon',n:'DP-300F',mass:12,mount:'half',vtfMin:2,vtfMax:3,arm:'pivoted'},
  {m:'Denon',n:'DP-400',mass:12,mount:'half',vtfMin:1,vtfMax:3,arm:'pivoted'},
  {m:'Denon',n:'DP-450USB',mass:12,mount:'half',vtfMin:1,vtfMax:3,arm:'pivoted'},
  {m:'Sony',n:'PS-LX310BT',mass:8,mount:'fixed',vtfMin:3,vtfMax:3,arm:'pivoted',notes:'Fixed cartridge'},
  {m:'Sony',n:'PS-HX500',mass:11,mount:'half',vtfMin:2,vtfMax:3,arm:'pivoted'},
  {m:'Clearaudio',n:'Concept',mass:13,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted',notes:'Verify magnetic bearing arm'},
  {m:'Clearaudio',n:'Concept Active',mass:13,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted'},
  {m:'VPI',n:'Player',mass:11,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted'},
  {m:'VPI',n:'Cliffwood',mass:11,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted'},
  {m:'VPI',n:'Prime Scout',mass:11,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted',notes:'JMW-9T unipivot'},
  {m:'Crosley',n:'C100',mass:8,mount:'half',vtfMin:2,vtfMax:4,arm:'pivoted'},
  {m:'Crosley',n:'C200',mass:8,mount:'half',vtfMin:2,vtfMax:4,arm:'pivoted'},
  {m:'Crosley',n:'C6',mass:8,mount:'half',vtfMin:2,vtfMax:4,arm:'pivoted'},
  {m:'Yamaha',n:'TT-S303',mass:11,mount:'half',vtfMin:1.5,vtfMax:3,arm:'pivoted'},
  {m:'Yamaha',n:'GT-5000',mass:18,mount:'half',vtfMin:1.5,vtfMax:3,arm:'pivoted'},
  {m:'Reloop',n:'RP-7000 MK2',mass:14,mount:'half',vtfMin:1,vtfMax:4,arm:'pivoted'},
  {m:'Reloop',n:'RP-8000 MK2',mass:14,mount:'half',vtfMin:1,vtfMax:4,arm:'pivoted'},
  {m:'Thorens',n:'TD-202',mass:11,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted'},
  {m:'Thorens',n:'TD-1601',mass:13,mount:'half',vtfMin:1.5,vtfMax:2.5,arm:'pivoted'},
  {m:'Linn',n:'LP12 (Akito)',mass:11,mount:'half',vtfMin:1.5,vtfMax:2,arm:'pivoted',notes:'Akito tonearm; varies by spec'},
  {m:'Linn',n:'Majik LP12',mass:11,mount:'half',vtfMin:1.5,vtfMax:2,arm:'pivoted'}
];

/* CARTRIDGES DB
 * Fields:
 *  m = manufacturer
 *  n = model
 *  type = 'MM' | 'MC' | 'MI'
 *  output = output voltage (mV) at 5cm/s
 *  mount = 'half' | 'p'
 *  weight = cartridge weight (g)
 *  vtfMin/vtfMax = recommended VTF range (g)
 *  comp = dynamic compliance @10Hz (×10^-6 cm/dyne). For specs @100Hz, multiply by ~1.7 to estimate 10Hz.
 *  load = recommended load impedance (Ω); for MC much lower
 */
const KTS_CC_CARTRIDGES = [
  {m:'Audio-Technica',n:'AT-VM95E',type:'MM',output:4,mount:'half',weight:6.1,vtfMin:1.8,vtfMax:2.2,comp:20,load:47000},
  {m:'Audio-Technica',n:'AT-VM95ML',type:'MM',output:3.5,mount:'half',weight:6.1,vtfMin:1.8,vtfMax:2.2,comp:20,load:47000},
  {m:'Audio-Technica',n:'AT-VM95SH',type:'MM',output:3.5,mount:'half',weight:6.1,vtfMin:1.8,vtfMax:2.2,comp:20,load:47000},
  {m:'Audio-Technica',n:'AT-VM95C',type:'MM',output:4,mount:'half',weight:6.1,vtfMin:1.8,vtfMax:2.2,comp:20,load:47000},
  {m:'Audio-Technica',n:'AT-VM540ML',type:'MM',output:4,mount:'half',weight:6.7,vtfMin:1.8,vtfMax:2.2,comp:20,load:47000},
  {m:'Audio-Technica',n:'AT-ART9XI',type:'MC',output:0.5,mount:'half',weight:8.5,vtfMin:1.8,vtfMax:2.2,comp:13,load:100},
  {m:'Audio-Technica',n:'AT-OC9XML',type:'MC',output:0.4,mount:'half',weight:8.4,vtfMin:1.8,vtfMax:2.2,comp:18,load:100},
  {m:'Audio-Technica',n:'AT3600L',type:'MM',output:2.5,mount:'p',weight:5.7,vtfMin:2.5,vtfMax:3.5,comp:15,load:47000,notes:'P-mount, sold with AT-LP60 series'},
  {m:'Audio-Technica',n:'AT91',type:'MM',output:3.5,mount:'half',weight:5.7,vtfMin:1.5,vtfMax:2.5,comp:20,load:47000},
  {m:'Ortofon',n:'2M Red',type:'MM',output:5.5,mount:'half',weight:7.2,vtfMin:1.6,vtfMax:2.0,comp:20,load:47000},
  {m:'Ortofon',n:'2M Blue',type:'MM',output:5.5,mount:'half',weight:7.2,vtfMin:1.6,vtfMax:2.0,comp:20,load:47000},
  {m:'Ortofon',n:'2M Bronze',type:'MM',output:5,mount:'half',weight:7.2,vtfMin:1.4,vtfMax:1.7,comp:22,load:47000},
  {m:'Ortofon',n:'2M Black',type:'MM',output:5,mount:'half',weight:7.2,vtfMin:1.4,vtfMax:1.7,comp:22,load:47000},
  {m:'Ortofon',n:'Quintet Red',type:'MC',output:0.5,mount:'half',weight:9.0,vtfMin:2.1,vtfMax:2.5,comp:15,load:100},
  {m:'Ortofon',n:'Quintet Black S',type:'MC',output:0.3,mount:'half',weight:9.0,vtfMin:2.1,vtfMax:2.5,comp:15,load:100},
  {m:'Ortofon',n:'Concorde MkII Mix',type:'MM',output:6,mount:'p',weight:18.5,vtfMin:3,vtfMax:4,comp:14,load:47000,notes:'DJ cartridge, P-mount style'},
  {m:'Sumiko',n:'Rainier',type:'MM',output:5,mount:'half',weight:6.5,vtfMin:1.8,vtfMax:2.2,comp:12,load:47000},
  {m:'Sumiko',n:'Olympia',type:'MM',output:5,mount:'half',weight:6.5,vtfMin:1.8,vtfMax:2.2,comp:12,load:47000},
  {m:'Sumiko',n:'Moonstone',type:'MM',output:5,mount:'half',weight:6.5,vtfMin:1.8,vtfMax:2.2,comp:12,load:47000},
  {m:'Sumiko',n:'Songbird',type:'MC',output:0.5,mount:'half',weight:9.4,vtfMin:1.8,vtfMax:2.2,comp:12,load:100},
  {m:'Sumiko',n:'Blue Point Special EVO III',type:'MC',output:2.5,mount:'half',weight:9.0,vtfMin:1.8,vtfMax:2.2,comp:12,load:47000,notes:'High-output MC, works with MM input'},
  {m:'Grado',n:'Black3',type:'MI',output:5,mount:'half',weight:5.5,vtfMin:1.5,vtfMax:1.9,comp:20,load:47000,notes:'Moving iron; needs grounded turntable, may hum on Technics'},
  {m:'Grado',n:'Green3',type:'MI',output:5,mount:'half',weight:5.5,vtfMin:1.5,vtfMax:1.9,comp:20,load:47000,notes:'May hum on Technics'},
  {m:'Grado',n:'Red3',type:'MI',output:5,mount:'half',weight:5.5,vtfMin:1.5,vtfMax:1.9,comp:20,load:47000,notes:'May hum on Technics'},
  {m:'Grado',n:'Gold3',type:'MI',output:5,mount:'half',weight:5.5,vtfMin:1.5,vtfMax:1.9,comp:20,load:47000,notes:'May hum on Technics'},
  {m:'Nagaoka',n:'MP-110',type:'MM',output:5,mount:'half',weight:6.5,vtfMin:1.5,vtfMax:2.5,comp:17,load:47000},
  {m:'Nagaoka',n:'MP-150',type:'MM',output:4,mount:'half',weight:7.0,vtfMin:1.5,vtfMax:2.0,comp:14,load:47000},
  {m:'Nagaoka',n:'MP-200',type:'MM',output:4,mount:'half',weight:7.5,vtfMin:1.5,vtfMax:2.0,comp:14,load:47000},
  {m:'Nagaoka',n:'MP-300',type:'MM',output:4,mount:'half',weight:8.0,vtfMin:1.5,vtfMax:2.0,comp:14,load:47000},
  {m:'Nagaoka',n:'MP-500',type:'MM',output:4,mount:'half',weight:8.0,vtfMin:1.5,vtfMax:2.0,comp:14,load:47000},
  {m:'Denon',n:'DL-103',type:'MC',output:0.3,mount:'half',weight:8.5,vtfMin:2.3,vtfMax:2.7,comp:5,load:100,notes:'Very low compliance; needs medium-to-high mass tonearm (>15g)'},
  {m:'Denon',n:'DL-103R',type:'MC',output:0.25,mount:'half',weight:8.5,vtfMin:2.3,vtfMax:2.7,comp:5,load:100,notes:'Low compliance; high-mass arm preferred'},
  {m:'Denon',n:'DL-110',type:'MC',output:1.6,mount:'half',weight:4.8,vtfMin:1.6,vtfMax:2.0,comp:15,load:47000,notes:'High-output MC, works with MM input'},
  {m:'Hana',n:'SL',type:'MC',output:0.5,mount:'half',weight:5.0,vtfMin:1.8,vtfMax:2.2,comp:10,load:100},
  {m:'Hana',n:'ML',type:'MC',output:0.4,mount:'half',weight:8.0,vtfMin:1.8,vtfMax:2.2,comp:10,load:100},
  {m:'Hana',n:'SH',type:'MC',output:2,mount:'half',weight:5.0,vtfMin:1.8,vtfMax:2.2,comp:10,load:47000,notes:'High-output MC, works with MM input'},
  {m:'Goldring',n:'1006 GX',type:'MM',output:6.5,mount:'half',weight:5.5,vtfMin:1.5,vtfMax:2.0,comp:16,load:47000},
  {m:'Goldring',n:'1012 GX',type:'MM',output:6.5,mount:'half',weight:5.5,vtfMin:1.5,vtfMax:2.0,comp:16,load:47000},
  {m:'Goldring',n:'1042 GX',type:'MM',output:6.5,mount:'half',weight:5.5,vtfMin:1.5,vtfMax:2.0,comp:16,load:47000},
  {m:'Pro-Ject',n:'Pick it PRO',type:'MM',output:5,mount:'half',weight:7.2,vtfMin:1.6,vtfMax:2.0,comp:20,load:47000,notes:'Rebadged Ortofon 2M Red Pro-Ject edition'},
  {m:'Rega',n:'Carbon',type:'MM',output:2.5,mount:'half',weight:5.5,vtfMin:1.5,vtfMax:2.5,comp:14,load:47000},
  {m:'Rega',n:'Bias 2',type:'MM',output:6.8,mount:'half',weight:6.0,vtfMin:1.5,vtfMax:2.0,comp:17,load:47000},
  {m:'Rega',n:'Exact',type:'MM',output:6.8,mount:'half',weight:6.0,vtfMin:1.5,vtfMax:2.0,comp:18,load:47000},
  {m:'Rega',n:'Ania',type:'MC',output:0.35,mount:'half',weight:6.0,vtfMin:1.7,vtfMax:1.9,comp:10,load:100}
];

function ktsCartridgeChecker() {
  return {
    turntables: KTS_CC_TURNTABLES,
    cartridges: KTS_CC_CARTRIDGES,
    ttIdx: -1,  // selected turntable index
    cartIdx: -1, // selected cartridge index
    showResult: false,
    result: null,

    init() {
      try {
        const p = new URLSearchParams(window.location.search);
        const t = p.get('t'); const c = p.get('c');
        if (t !== null) this.ttIdx = parseInt(t, 10);
        if (c !== null) this.cartIdx = parseInt(c, 10);
        if (this.ttIdx >= 0 && this.cartIdx >= 0) this.check();
      } catch (e) {}
    },

    get tt() { return this.ttIdx >= 0 ? this.turntables[this.ttIdx] : null; },
    get cart() { return this.cartIdx >= 0 ? this.cartridges[this.cartIdx] : null; },

    /* Cartridges filtered by turntable mount type */
    get compatibleCartridges() {
      if (!this.tt) return this.cartridges.map((c, i) => ({ c, i }));
      if (this.tt.mount === 'fixed') return [];
      return this.cartridges
        .map((c, i) => ({ c, i }))
        .filter(o => o.c.mount === this.tt.mount);
    },

    /* Group turntables by manufacturer for select grouping */
    get turntableGroups() {
      const g = {};
      this.turntables.forEach((t, i) => {
        if (!g[t.m]) g[t.m] = [];
        g[t.m].push({ t, i });
      });
      return Object.keys(g).sort().map(k => ({ name: k, items: g[k] }));
    },

    get cartridgeGroups() {
      const list = this.compatibleCartridges;
      const g = {};
      list.forEach(o => {
        if (!g[o.c.m]) g[o.c.m] = [];
        g[o.c.m].push(o);
      });
      return Object.keys(g).sort().map(k => ({ name: k, items: g[k] }));
    },

    resonance(armMass, cartWeight, comp) {
      // f = 1000 / (2π × √((M+m) × C))
      if (!comp || !armMass || !cartWeight) return 0;
      return 1000 / (2 * Math.PI * Math.sqrt((armMass + cartWeight) * comp));
    },

    check() {
      const tt = this.tt; const c = this.cart;
      if (!tt || !c) return;

      const notes = [];
      let verdict = 'green'; // green, yellow, red
      let headline = _ccT('verdict_green_h', 'Excellent match');
      let summary = _ccT('verdict_green_sub', 'This combination pairs cleanly. Set up with the values below and enjoy.');

      // 1) Mount compatibility
      if (tt.mount === 'fixed') {
        verdict = 'red';
        headline = _ccT('verdict_red_h', 'Not compatible');
        summary = _ccT('verdict_fixed_sub', 'This turntable has a fixed cartridge that cannot be replaced.');
        notes.push({ level: 'bad', t: _ccT('note_fixed', 'Fixed cartridge — cannot be swapped without replacing the whole tonearm/headshell assembly.') });
      } else if (tt.mount !== c.mount) {
        verdict = 'red';
        headline = _ccT('verdict_red_h', 'Not compatible');
        summary = _ccT('verdict_mount_sub', 'Mount type does not match. P-mount turntables only accept P-mount cartridges and vice versa.');
        notes.push({ level: 'bad', t: _ccT('note_mount', 'Mount mismatch: ') + tt.mount + ' vs ' + c.mount });
      }

      // 2) Resonance
      const totalMass = tt.mass + c.weight;
      const freq = this.resonance(tt.mass, c.weight, c.comp);
      let resonanceLevel = 'green';
      let resonanceMsg = '';
      if (freq < 6 || freq > 14) {
        resonanceLevel = 'red';
        resonanceMsg = _ccT('reso_bad', 'Resonance outside the 6–14 Hz safe window. Expect footfall pickup or audible vibration.');
      } else if (freq < 8 || freq > 12) {
        resonanceLevel = 'yellow';
        resonanceMsg = _ccT('reso_yellow', 'Resonance just outside the 8–12 Hz optimal window but inside the safe range.');
      } else {
        resonanceLevel = 'green';
        resonanceMsg = _ccT('reso_green', 'Resonance is in the optimal 8–12 Hz window. Great tracking expected.');
      }

      if (verdict !== 'red' && resonanceLevel === 'red') {
        verdict = 'red';
        headline = _ccT('verdict_red_h', 'Not compatible');
        summary = _ccT('verdict_reso_sub', 'Resonance is outside the safe range — this combination will skip on footfalls or pick up audible vibration.');
      } else if (verdict === 'green' && resonanceLevel === 'yellow') {
        verdict = 'yellow';
        headline = _ccT('verdict_yellow_h', 'Workable with caveats');
        summary = _ccT('verdict_yellow_sub', 'This combination works, but is not optimal. See notes below for trade-offs.');
      }

      notes.push({ level: resonanceLevel === 'green' ? 'ok' : (resonanceLevel === 'yellow' ? 'warn' : 'bad'), t: resonanceMsg });

      // 3) MC output level vs phono stage
      if (c.type === 'MC' && c.output < 1) {
        notes.push({ level: 'warn', t: _ccT('note_mc_low', 'Low-output MC cartridge — requires a dedicated MC phono stage or a step-up transformer.') });
      } else if (c.type === 'MC' && c.output >= 1) {
        notes.push({ level: 'ok', t: _ccT('note_mc_high', 'High-output MC — works with a standard MM phono input.') });
      }

      // 4) Cartridge custom notes
      if (c.notes) notes.push({ level: 'warn', t: c.notes });
      if (tt.notes) notes.push({ level: 'warn', t: tt.notes });

      // 5) Suggested VTF (mid of cartridge range, clamped by turntable range)
      let suggestedVTF = (c.vtfMin + c.vtfMax) / 2;
      if (suggestedVTF < tt.vtfMin) suggestedVTF = tt.vtfMin;
      if (suggestedVTF > tt.vtfMax) suggestedVTF = tt.vtfMax;

      // 6) Anti-skate ≈ VTF
      const antiSkate = suggestedVTF;

      // 7) Alignment recommendation
      let alignment = 'Baerwald (Löfgren A)';
      let alignmentExplain = _ccT('align_baerwald', 'Best general-purpose alignment — minimizes tracking distortion across typical groove diameters.');

      // 8) Total mass for display
      const cap = totalMass.toFixed(1);

      this.result = {
        verdict, headline, summary,
        notes,
        freq: freq.toFixed(2),
        totalMass: cap,
        suggestedVTF: suggestedVTF.toFixed(2),
        antiSkate: antiSkate.toFixed(2),
        alignment, alignmentExplain,
        loadImpedance: c.load,
        outputLevel: c.output,
        cartType: c.type
      };
      this.showResult = true;

      // Save state to URL for shareability
      try {
        const u = new URL(window.location.href);
        u.searchParams.set('t', this.ttIdx);
        u.searchParams.set('c', this.cartIdx);
        window.history.replaceState({}, '', u);
      } catch (e) {}

      // Smooth scroll to result
      setTimeout(() => {
        const el = document.getElementById('kts-cc-result');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    },

    reset() {
      this.ttIdx = -1;
      this.cartIdx = -1;
      this.showResult = false;
      this.result = null;
      try {
        const u = new URL(window.location.href);
        u.searchParams.delete('t');
        u.searchParams.delete('c');
        window.history.replaceState({}, '', u);
      } catch (e) {}
    },

    shareUrl() {
      const url = window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => alert(_ccT('share_copied', 'Result URL copied. Paste anywhere to share.')));
      } else {
        window.prompt(_ccT('share_prompt', 'Copy this URL to share:'), url);
      }
    }
  };
}
